import React from 'react';
import BackButton from 'components/BackButton';
import { StyledBlock, StyledTitle, StyledDescription } from '../StyledComponents';
import ActionsSection from '../ActionsSection';
import i18n from 'i18n';
import { showToast } from 'actions/toast';
import { setParentalPurchase, setParentalIsEnabled } from 'actions/parental-lock';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsPurchaseProtected, selectParentalControlAge } from 'reducers/parental-lock/selectors';

const ParentalLockPurchasePage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const age = useSelector(selectParentalControlAge);
  const isPurchaseProtected = useSelector(selectIsPurchaseProtected);

  const onEnter = (isEnabled) => {
    dispatch(setParentalPurchase(isEnabled));
    dispatch(setParentalIsEnabled(isEnabled || age !== 'PG'));
    dispatch(showToast({ options: { toastText: i18n.t('pc.saveChanges') } }));

    innerAnalyticsVolia.postEvent({
      eventGroup: 'profile',
      eventName: `purchases protection`,
      eventValue: isEnabled ? 'on' : 'off',
    });

    history.goBack();
  };

  return (
    <>
      <BackButton onEnter={history.goBack} />
      <div>
        <StyledBlock>
          <StyledTitle>{i18n.t('pc.purchase.title')}</StyledTitle>
        </StyledBlock>
        <StyledBlock>
          <StyledDescription>{i18n.t('pc.purchase.description')}</StyledDescription>
        </StyledBlock>
        <StyledBlock>
          <ActionsSection defaultSection>
            <ActionsSection.Button
              onEnter={() => onEnter(false)}
              label={i18n.t('pc.purchase.restrictionOFF')}
              type={'tick-button'}
              selected={isPurchaseProtected === false}
            />
            <ActionsSection.Button
              onEnter={() => onEnter(true)}
              label={i18n.t('pc.purchase.restrictionON')}
              type={'tick-button'}
              selected={isPurchaseProtected === true}
            />
          </ActionsSection>
        </StyledBlock>
      </div>
    </>
  );
};

export default ParentalLockPurchasePage;
